export var BankCode;
(function (BankCode) {
    BankCode["BAGAGE22"] = "BAGAGE22";
    BankCode["TBCBGE22"] = "TBCBGE22";
    BankCode["JSCRGE22"] = "JSCRGE22";
    BankCode["ISBKGE22"] = "ISBKGE22";
    BankCode["PAHAGE22"] = "PAHAGE22";
    BankCode["HABGGE22"] = "HABGGE22";
    BankCode["DISNGE22"] = "DISNGE22";
    BankCode["MIBGGE22"] = "MIBGGE22";
    BankCode["TCZBGE22"] = "TCZBGE22";
    BankCode["CRTUGE22"] = "CRTUGE22";
    BankCode["CBASGE22"] = "CBASGE22";
    BankCode["LBRTGE22"] = "LBRTGE22";
    BankCode["TEBAGE22"] = "TEBAGE22";
    BankCode["BZENLT22"] = "BZENLT22";
})(BankCode || (BankCode = {}));
//# sourceMappingURL=bank-code.enum.js.map